module.exports = __webpack_public_path__ + "static/img/flycard-btu.3224b198.jpg";